export const CONSENT_CREATION_FAILURE = 'consentCreationFailure';
export const OBK_SCRAPE_FAILED = 'obkScrapeFailed';

export const OBKConnectionErrors = [CONSENT_CREATION_FAILURE, OBK_SCRAPE_FAILED];
